export default {
  filters: {
    formateTotalAmount (value) {
      return parseFloat(value).toFixed(2)
    },
    formatFloat (value) {
      // return Math.floor(value * 100) / 100   ==== 9999.79
      return (parseFloat(value * 100) / 100).toFixed(2)
    }
  }
}
